export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-link-1ec6fbc4c586975f0315825bc8f27491.svg";